import Text from '../../components/Text';
import { fontSizes, pdfsPath } from '../../constants/constants';
import orderStatusFunctional from './index.function';
import ViewReverse from '../../components/ViewReverse';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import dayjs from 'dayjs';
import icons from '../../constants/icons';
import CustomTable from '../../components/CustomTable';
import { orderStatusColumn } from '../../config/config';
import { ReactSVG } from 'react-svg';
import { formatNumbers } from '../../utils/utils';
import SarSymbol from '../../components/SarSymbol';
const OrderStatus = () => {
  const {
    isArabic,
    buy_order_data,
    buy_order_loading,
    sell_order_data,
    sell_order_loading,
    single_Buy_order_data,
    single_Buy_order_loading,
    single_sell_order_data,
    single_sell_order_loading,
    TextWeight,
    getContentKey,
    buyOrderReviewModal,
    setBuyOrderReviewModal,
    buyOrderToogleReviewModal,
    sellOrderReviewModal,
    setSellOrderReviewModal,
    sellOrderToogleReviewModal,
    buyView,
    setBuyView,
    sellView,
    setSellView,
    navigate,
    handleAcceptBuyOrder,
    handleCancelBuyOrder,
    handleAcceptSellOrder,
    handleCancelSellOrder,
    dispatch,
    getSingleBuyOrder,
    user,
    getSingleSellOrder,
    order_accept_loading,
    order_cancel_loading,
    buyNoUnits,
    sellNoUnits,
  } = orderStatusFunctional();

  return (
    <div className='min-h-full'>
      <div className={'mb-3 sm:mb-5'}>
        <Text text={getContentKey('heading')} size={fontSizes.h18} color='text-black' weight={TextWeight.bold} isTruncate={false} />
      </div>

      <CustomTable
        heading={getContentKey('buy_table_heading')}
        headCells={isArabic ? orderStatusColumn(getContentKey)?.reverse() : orderStatusColumn(getContentKey)}
        isbutton={true}
        getContentKeyOrder={getContentKey('buy_units_btn')}
        getContentKeyViewAction={getContentKey('view_action_btn')}
        rightIcon={icons.buyUnitsBtn}
        isOpen
        isBorder={false}
        onClick={(row) => {
          setBuyView(row);
          dispatch(getSingleBuyOrder(row.orderNo, user?.investorTypeId));
          setBuyOrderReviewModal(true);
        }}
        loading={buy_order_loading}
        btnOnClick={() => navigate('/funds/buy-order')}
        isClientSuspended={user?.isClientSuspended}
        data={buy_order_data?.map((order) => ({
          orderNo: order?.id || '-',
          fund: order?.fund || '-',
          units:
            (order?.currentProcessStage === 'Awaiting Acceptance Of Others' ||
              order?.currentProcessStage === 'Awaiting Trade Execution' ||
              order?.currentProcessStage === 'Completed'
              ? order?.unitsApproved
              : order?.unitsRequested) || '-',
          status: order?.currentProcessStage || '-',
          date: new Date(order?.createdDate).toLocaleDateString('en-GB') || '-',
        }))}
      />

      <div className='mt-3 sm:mt-5'>
        <CustomTable
          heading={getContentKey('sell_table_heading')}
          headCells={isArabic ? orderStatusColumn(getContentKey)?.reverse() : orderStatusColumn(getContentKey)}
          isbutton={true}
          getContentKeyOrder={getContentKey('sell_units_btn')}
          getContentKeyViewAction={getContentKey('view_action_btn')}
          rightIcon={icons.sellUnitsBtn}
          isOpen
          isBorder={false}
          onClick={(row) => {
            setSellView(row);
            dispatch(getSingleSellOrder(row.orderNo, user?.investorTypeId));
            setSellOrderReviewModal(true);
          }}
          loading={sell_order_loading}
          btnOnClick={() => navigate('/funds/sell-order')}
          // isClientSuspended={user?.isClientSuspended}
          data={sell_order_data?.map((order) => ({
            orderNo: order?.id || '-',
            fund: order?.fund || '-',
            units:
              (order?.currentProcessStage === 'Awaiting Acceptance Of Others' ||
                order?.currentProcessStage === 'Awaiting Trade Execution' ||
                order?.currentProcessStage === 'Completed'
                ? order?.unitsApproved
                : order?.unitsRequested) || '-',
            status: order?.currentProcessStage || '-',
            date: new Date(order?.createdDate).toLocaleDateString('en-GB') || '-',
          }))}
        />
      </div>

      {/* buy order */}
      <CustomModal
        isOpen={buyOrderReviewModal}
        heading={getContentKey(
          buyView?.status === 'Awaiting Client Acceptance'
            ? 'waiting_client_acceptance'
            : buyView?.status === 'Wealth Manger Approval'
              ? 'wealth_manger_approval'
              : buyView?.status === 'Rejected'
                ? 'your_order_rejected'
                : buyView?.status === 'Waiting Trade Execution'
                  ? 'waiting_trade_execution'
                  : buyView?.status === 'Matching By Operations'
                    ? 'matching_operations'
                    : buyView?.status === 'Compliance Approval'
                      ? 'compliance_approval'
                      : buyView?.status === 'Wealth Manager Approval'
                        ? 'wealth_manger_approval'
                        : buyView?.status === 'Awaiting Acceptance Of Others'
                          ? 'avaiting_acceptance_others'
                          : buyView?.status === 'Awaiting Trade Execution'
                            ? 'avaiting_trade_execution'
                            : buyView?.status === 'Canceled'
                              ? 'your_order_canceled'
                              : buyView?.status === 'Completed'
                                ? 'your_order_completed'
                                : ''
        )}
        color={'text-black'}
        size={fontSizes.h20}
        loading={single_Buy_order_loading}
        isFullWidth
        onClose={buyOrderToogleReviewModal}
      >
        {(buyView?.status === 'Awaiting Client Acceptance' ||
          buyView?.status === 'Waiting Trade Execution' ||
          buyView?.status === 'Awaiting Acceptance Of Others' ||
          buyView?.status === 'Awaiting Trade Execution') && (
            <>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey mt-3'}>
                <Text text={getContentKey('order_no')} size={fontSizes.h14} />
                <Text text={single_Buy_order_data?.id} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('funds')} size={fontSizes.h14} />
                <Text text={single_Buy_order_data?.fund} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('units_required')} size={fontSizes.h14} />
                <Text text={formatNumbers(single_Buy_order_data?.unitsRequested ?? 0, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('units_approved')} size={fontSizes.h14} />
                <Text text={formatNumbers(single_Buy_order_data?.unitsApproved ?? 0, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('price')} size={fontSizes.h14} />
                <ViewReverse isReverse={false}>
                  <SarSymbol color={'text-primary'} />
                  <Text text={formatNumbers(single_Buy_order_data?.priceApproved)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
                </ViewReverse>
              </ViewReverse>
              {/* <ViewReverse
              className={'justify-between border-b py-2 border-b-grey'}
            >
              <Text text={getContentKey('fees')} size={fontSizes.h14} />
              <ViewReverse isReverse={false} className={'gap-1 items-center'}>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={`(${formatNumbers(
                    single_Buy_order_data?.feePercent ?? 0
                  )}%)`}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
            </ViewReverse> */}
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('order_type')} size={fontSizes.h14} />
                <Text text={getContentKey('order_type_buying')} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>

              <ViewReverse className={'justify-between py-2'}>
                <Text text={getContentKey('date_submission')} size={fontSizes.h14} />
                <Text
                  text={dayjs(single_Buy_order_data?.createdDate).format('DD MMM, YYYY')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              {buyView?.status === 'Awaiting Client Acceptance' ? (
                <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                  <Button
                    text={getContentKey('accept_btn')}
                    bgColor='bg-primary'
                    className={'w-full px-0 text-center capitalize border border-orange'}
                    onClick={handleAcceptBuyOrder}
                    loading={order_accept_loading}
                  />
                  <Button
                    text={getContentKey('deny_btn')}
                    loaderColor='border-t-primary'
                    bgColor='bg-white'
                    color='text-primary'
                    className={'w-full rounded-lg capitalize py-2 text-center border border-primary'}
                    loading={order_cancel_loading}
                    onClick={handleCancelBuyOrder}
                  />
                </ViewReverse>
              ) : (
                <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                  <Button
                    text={getContentKey('okay_btn')}
                    bgColor='bg-primary'
                    className={'w-full px-0 text-center capitalize border border-orange'}
                    onClick={() => {
                      setBuyOrderReviewModal(false);
                    }}
                  />
                </ViewReverse>
              )}
            </>
          )}

        {(buyView?.status === 'Rejected' ||
          buyView?.status === 'Matching By Operations' ||
          buyView?.status === 'Compliance Approval' ||
          buyView?.status === 'Wealth Manager Approval' ||
          buyView?.status === 'Canceled' ||
          buyView?.status === 'Completed') && (
            <>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey mt-3'}>
                <Text text={getContentKey('funds')} size={fontSizes.h14} />
                <Text text={single_Buy_order_data?.fund} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('termsand_conditions')} size={fontSizes.h14} />
                <ViewReverse className={'gap-3 items-center cursor-pointer'} onClick={() => window.open(pdfsPath.terms_conditions, '_blank')}>
                  <Text
                    text={dayjs(single_Buy_order_data?.createdDate).format('DD MMM, YYYY')}
                    size={fontSizes.h14}
                    color='text-primary'
                    weight={TextWeight.semiBold}
                  />
                  <ReactSVG src={icons?.viewActionbtn} className='cursor-pointer' />
                </ViewReverse>
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('no_units')} size={fontSizes.h14} />
                <Text text={formatNumbers(buyNoUnits, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              {/* <ViewReverse
              className={'justify-between border-b py-2 border-b-grey'}
            >
              <Text
                text={getContentKey('subscription_fee')}
                size={fontSizes.h14}
              />
              <ViewReverse isReverse={false} className={'gap-1 items-center'}>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={`(${formatNumbers(
                    single_Buy_order_data?.feePercent
                  )}%)`}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
            </ViewReverse> */}
              {/* <ViewReverse
              className={'justify-between border-b py-2 border-b-grey'}
            >
              <Text text={getContentKey('vat')} size={fontSizes.h14} />
              <Text
                text={single_Buy_order_data?.vat}
                size={fontSizes.h14}
                color='text-primary'
                weight={TextWeight.semiBold}
              />
            </ViewReverse> */}

              {/* {single_Buy_order_data?.documents?.length > 0 && (
              <ViewReverse
                className={'justify-between border-b py-2 border-b-grey'}
              >
                <Text text={getContentKey('document')} size={fontSizes.h14} />
                <ViewReverse className={'gap-3 items-center'}>
                  <Text
                    text={single_Buy_order_data?.documents?.[0]?.fileName}
                    size={fontSizes.h14}
                    color='text-primary'
                    weight={TextWeight.semiBold}
                  />
                  <ReactSVG
                    src={icons?.viewActionbtn}
                    className='cursor-pointer'
                  />
                </ViewReverse>
              </ViewReverse>
            )} */}

              <ViewReverse className={'justify-between py-2'}>
                <Text text={getContentKey('date')} size={fontSizes.h14} />
                <Text
                  text={dayjs(single_Buy_order_data?.createdDate).format('DD MMM, YYYY')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                <Button
                  text={getContentKey('okay_btn')}
                  bgColor='bg-primary'
                  className={'w-full px-0 text-center capitalize border border-orange'}
                  onClick={() => {
                    setBuyOrderReviewModal(false);
                  }}
                />
              </ViewReverse>
            </>
          )}
      </CustomModal>

      {/* sell order */}
      <CustomModal
        isOpen={sellOrderReviewModal}
        heading={getContentKey(
          sellView?.status === 'Awaiting Client Acceptance'
            ? 'waiting_client_acceptance'
            : sellView?.status === 'Wealth Manger Approval'
              ? 'wealth_manger_approval'
              : sellView?.status === 'Rejected'
                ? 'your_order_rejected'
                : sellView?.status === 'Waiting Trade Execution'
                  ? 'waiting_trade_execution'
                  : sellView?.status === 'Matching By Operations'
                    ? 'matching_operations'
                    : sellView?.status === 'Compliance Approval'
                      ? 'compliance_approval'
                      : sellView?.status === 'Wealth Manager Approval'
                        ? 'wealth_manger_approval'
                        : sellView?.status === 'Awaiting Acceptance Of Others'
                          ? 'avaiting_acceptance_others'
                          : sellView?.status === 'Awaiting Trade Execution'
                            ? 'avaiting_trade_execution'
                            : sellView?.status === 'Canceled'
                              ? 'your_order_canceled'
                              : sellView?.status === 'Completed'
                                ? 'your_order_completed'
                                : ''
        )}
        color={'text-black'}
        size={fontSizes.h22}
        loading={single_sell_order_loading}
        isFullWidth
        onClose={sellOrderToogleReviewModal}
      >
        {(sellView?.status === 'Awaiting Client Acceptance' ||
          sellView?.status === 'Waiting Trade Execution' ||
          sellView?.status === 'Awaiting Acceptance Of Others' ||
          sellView?.status === 'Awaiting Trade Execution') && (
            <>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey mt-3'}>
                <Text text={getContentKey('order_no')} size={fontSizes.h14} />
                <Text text={single_sell_order_data?.id} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('funds')} size={fontSizes.h14} />
                <Text text={single_sell_order_data?.fund} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('units_required')} size={fontSizes.h14} />
                <Text text={formatNumbers(single_sell_order_data?.unitsRequested ?? 0, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('units_approved')} size={fontSizes.h14} />
                <Text text={formatNumbers(single_sell_order_data?.unitsApproved ?? 0, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('price')} size={fontSizes.h14} />
                <ViewReverse isReverse={false}>
                  <SarSymbol color={'text-primary'} />
                  <Text text={formatNumbers(single_sell_order_data?.priceApproved)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
                </ViewReverse>
              </ViewReverse>
              {/* <ViewReverse
              className={'justify-between border-b py-2 border-b-grey'}
            >
              <Text text={getContentKey('fees')} size={fontSizes.h14} />
              <ViewReverse isReverse={false} className={'gap-1 items-center'}>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={`(${formatNumbers(
                    single_sell_order_data?.feePercent
                  )}%)`}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
            </ViewReverse> */}
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('order_type')} size={fontSizes.h14} />
                <Text text={getContentKey('order_type_selling')} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>

              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('date_submission')} size={fontSizes.h14} />
                <Text
                  text={dayjs(single_sell_order_data?.createdDate).format('DD MMM, YYYY')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              {sellView?.status === 'Awaiting Client Acceptance' ? (
                <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                  <Button
                    text={getContentKey('accept_btn')}
                    bgColor='bg-primary'
                    className={'w-full px-0 text-center capitalize border border-orange'}
                    onClick={handleAcceptSellOrder}
                    loading={order_accept_loading}
                  />
                  <Button
                    text={getContentKey('deny_btn')}
                    loaderColor='border-t-primary'
                    bgColor='bg-white'
                    color='text-primary'
                    className={'w-full rounded-lg capitalize py-2 text-center border border-primary'}
                    loading={order_cancel_loading}
                    onClick={handleCancelSellOrder}
                  />
                </ViewReverse>
              ) : (
                <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                  <Button
                    text={getContentKey('okay_btn')}
                    bgColor='bg-primary'
                    className={'w-full px-0 text-center capitalize border border-orange'}
                    onClick={() => {
                      setSellOrderReviewModal(false);
                    }}
                  />
                </ViewReverse>
              )}
            </>
          )}

        {(sellView?.status === 'Rejected' ||
          sellView?.status === 'Matching By Operations' ||
          sellView?.status === 'Compliance Approval' ||
          sellView?.status === 'Wealth Manager Approval' ||
          sellView?.status === 'Canceled' ||
          sellView?.status === 'Completed') && (
            <>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey mt-3'}>
                <Text text={getContentKey('funds')} size={fontSizes.h14} />
                <Text text={single_sell_order_data?.fund} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>
              <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
                <Text text={getContentKey('no_units')} size={fontSizes.h14} />
                <Text text={formatNumbers(sellNoUnits, 0)} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
              </ViewReverse>

              <ViewReverse className={'justify-between py-2'}>
                <Text text={getContentKey('date')} size={fontSizes.h14} />
                <Text
                  text={dayjs(single_sell_order_data?.createdDate).format('DD MMM, YYYY')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
                <Button
                  text={getContentKey('okay_btn')}
                  bgColor='bg-primary'
                  className={'w-full px-0 text-center capitalize border border-orange'}
                  onClick={() => {
                    setSellOrderReviewModal(false);
                  }}
                />
              </ViewReverse>
            </>
          )}
      </CustomModal>
    </div>
  );
};

export default OrderStatus;
